import { Component, OnInit } from '@angular/core'
import { AuthService } from './login/services/auth.service'
import { NotificationsService } from './components/notifications-bell/notifications.service'
import { PerformanceMonitoringService } from '../core/services/performance-monitoring.service'

@Component({
  selector: 'fs-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  loaded = false
  constructor(
    public service: AuthService,
    private readonly notifications: NotificationsService,
    private readonly performanceMonitoring: PerformanceMonitoringService,
  ) {}

  ngOnInit(): void {
    this.loaded = !this.service.loading
    if (this.isNotIframe()) this.performanceMonitoring.start()
    if (this.isNotIframe() && !this.isLoginPage()) {
      this.notifications.startPolling()
    }
  }

  isNotIframe() {
    return window.self === window.top
  }

  isLoginPage() {
    return window.location.pathname === '/login'
  }
}
